import React from 'react';
import PropTypes from 'prop-types';
import { Label, Icon, Popup } from 'semantic-ui-react';
import { getCloneStatus } from './cloneStatusConfig';

/**
 * CloneStatusBadge
 *
 * Compact status label for a voice-clone row — mirrors the styling used
 * by the variation-status badges so the two pipelines look consistent.
 */
const CloneStatusBadge = ({ statusKey, size = 'tiny', showTooltip = true }) => {
  const s = getCloneStatus(statusKey);

  const label = (
    <Label
      size={size}
      color={s.color}
      style={{
        minWidth: '92px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '4px',
        lineHeight: 1
      }}
    >
      <Icon
        name={s.icon}
        style={{
          margin: 0,
          height: '1em',
          lineHeight: '1em',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      />
      <span
        style={{
          height: '1em',
          lineHeight: '1em',
          display: 'inline-flex',
          alignItems: 'center'
        }}
      >
        {s.label}
      </span>
    </Label>
  );

  if (!showTooltip) return label;

  return (
    <Popup
      trigger={label}
      content={s.description}
      position="top center"
      size="small"
      on={['hover', 'focus']}
    />
  );
};

CloneStatusBadge.propTypes = {
  statusKey: PropTypes.string,
  size: PropTypes.string,
  showTooltip: PropTypes.bool
};

export default CloneStatusBadge;
